
/* injects from baggage-loader */

'use strict';

import ProductComponent from './product.component';

// Child states
import ProductOverviewPage from './overview/product.overview.module';
import ProductDocumentsPage from './documents/product.documents.module';
import ProductActivityPage from './activity/product.activity.module';
import ProductCodePage from './code/product.code.module';
import ProductInfoPage from './info/product.info.module';
import ProductVariantsPage from './variants/product.variants.module';

const ProductPageModule = angular.module('product-module', [
    'ui.router',

    // Child states
    ProductOverviewPage.name,
    ProductDocumentsPage.name,
    ProductActivityPage.name,
    ProductCodePage.name,
    ProductInfoPage.name,
    ProductVariantsPage.name,

  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/overview');

    $stateProvider
      .state('product', {
        url: '/product/{id}',
        component: 'product',
        abstract: true,
        data: {
          title: 'Product',
          backRoute: 'products',
          backText: ''
        },
        // Resolve promises into controller bindings, see component for bindings
        resolve: { 
          product: function (Product, $transition$) {
            // if ($transition$.params('to').id === 'new') {
            //   let product = new Product();
            //   return product.save();
            // } else {
            //   return Product.get($transition$.params('to').id);
            // }
            return Product.get($transition$.params('to').id, {
              include: ['parent']
            });
          }
        },
        parentNavBar: [
          {
            title: 'Overview',
            icon: 'fa-th-large',
            state: 'product.overview'
          },
          // {
          //   title: 'Info',
          //   icon: 'fa-info-circle',
          //   state: 'product.info'
          // },
          {
            // TODO: need to hide this tab when product is itself a variant
            title: 'Variants',
            icon: 'fa-th-list',
            state: 'product.variants',
            hidden: false,
          },
          {
            title: 'Documents',
            icon: 'fa-file-text',
            state: 'product.documents'
          },
          {
            title: 'Activity',
            icon: 'fa-th-list',
            state: 'product.activity'
          },
          {
            title: 'Field Logs',
            icon: 'fa-book',
            state: 'product.fieldlogs'
          },
          {
            title: 'QR Code',
            icon: 'fa-qrcode',
            state: 'product.code'
          }
        ]
      });
  })
  .component('product', new ProductComponent());

export default ProductPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/product/product.module.js